<template>
  <!-- 我要加入 -->
  <div class="index-container">
    <bannerImg bannerText="我要加入" :isShowTab="true"></bannerImg>
    <personalSidebar>
      <div class="right-content">
        <div class="r-title">个人信息</div>
        <div class="info-content">
          <div class="module-box">
            <div class="info-name">姓名</div>
            <div class="info-input">
              <el-input placeholder="请输入姓名" v-model="info.real_name"></el-input>
            </div>
            <div class="info-name">手机号</div>
            <div class="info-input">
              <el-input class="phone-input" placeholder="请输入您的本人手机号" v-model="info.phone"></el-input>
              <span>|</span>
              <span class="code-text" @click="getCode">{{ codeText }}</span>
            </div>
            <div class="info-name">验证码</div>
            <div class="info-input">
              <el-input placeholder="请输入手机验证码" v-model="info.code"></el-input>
            </div>
            <div class="info-name">公司名称</div>
            <div class="info-input">
              <el-input placeholder="请输入公司名称" v-model="info.company_name"></el-input>
            </div>
          </div>
          <div class="module-box">
            <div class="card-text">
              <div class>身份证</div>
              <div class="right-text">
                <i class="iconfont-icon icon-wenhao"></i> 认证指引
              </div>
            </div>
            <div class="card-img-box">
              <el-upload
                :show-file-list="false"
                :on-success="successUpload"
                class="upload-box"
                :action="uploadUrl"
              >
                <img v-if="id_card_copy" class="card-imgs" :src=" imgUrl + id_card_copy" alt />
                <template v-else>
                  <i class="el-icon-plus"></i>
                  <div class="el-upload-tip">上传身份证正面</div>
                </template>
              </el-upload>
              <el-upload
                :show-file-list="false"
                class="upload-box"
                :on-success="successUploadtwo"
                :action="uploadUrl"
              >
                <img
                  v-if="id_card_national"
                  class="card-imgs"
                  :src=" imgUrl + id_card_national"
                  alt
                />
                <template v-else>
                  <i class="el-icon-plus"></i>
                  <div class="el-upload-tip">上传身份证背面</div>
                </template>
              </el-upload>
            </div>
            <div class="card-img-box">
              <div class="eg-text" @click="loogCard('front')">示例</div>
              <div class="eg-text" @click="loogCard('back')">示例</div>
            </div>
          </div>
          <div class="confirm-button" @click="submit">完成认证</div>
        </div>
      </div>
    </personalSidebar>
    <el-dialog :visible.sync="dialogVisible" width="26%">
      <div class="card-img" :style="{ backgroundImage: 'url( ' + cardImg + ')' }"></div>
      <div class="text-tip">{{ cardText }}</div>
    </el-dialog>
  </div>
</template>
<script>
import bannerImg from '../components/bannerImg.vue';
import personalSidebar from '../components/personalSidebar.vue';
import cardFront from '@/assets/img/shili_zheng_bc.png';
import cardBack from '@/assets/img/shili_fan_bc.png';
import api from '../api/api';
import { upload_url } from '../api/index';
import { imgUrl } from '../api/index';
const phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;

export default {
  name: 'editInfo',
  components: {
    bannerImg,
    personalSidebar
  },
  data() {
    return {
      info: {
        real_name: '',
        phone: '',
        code: '',
        company_name: ''
      },
      uploadUrl: upload_url,
      cardImg: '',
      cardFront: cardFront,
      cardBack: cardBack,
      dialogVisible: false,
      cardText: '',
      num: 60,
      isButton: false,
      codeText: '获取验证码',
      id_card_copy: '',
      id_card_national: '',
      imgUrl: imgUrl,
      is_archive: 0
    };
  },
  created() {
    this.getDetail();
  },
  mounted() {
    scrollTo(0, 0);
  },
  methods: {
    //   获取详情
    getDetail() {
      api.getMyinfo().then(res => {
        console.log(res);
        if (res.result) {
          this.info = res.result;
          this.id_card_copy = res.result.id_card_copy;
          this.id_card_national = res.result.id_card_national;
          this.is_archive = res.result.is_archive;
        }
      });
    },
    //   发送验证码
    getCode() {
      if (this.isButton) {
        return;
      }
      if (!this.info.phone) {
        this.$message.warning('请输入手机号!');
      } else {
        this.getyzm();
        const params = {
          mobile: this.info.phone
        };
        api.sendCode(params).then(res => {
          console.log(res);
          if (res.result) {
            this.$message.success('发送成功！');
          } else {
            this.$message.warning('发送失败！');
          }
        });
      }
    },
    getyzm() {
      this.isButton = true;
      let i = 60;
      let timer = setInterval(() => {
        this.codeText = i + 's';
        i--;
        if (i < 0) {
          this.isButton = false;
          this.codeText = '获取验证码';
          clearInterval(timer);
        }
      }, 1000);
    },
    loogCard(type) {
      this.cardImg = type === 'front' ? this.cardFront : this.cardBack;
      this.cardText = type === 'front' ? '身份证正面' : '身份证背面';
      this.dialogVisible = true;
    },
    // 上传成功
    successUpload(res, file) {
      console.log(res);
      if (res.result) {
        this.id_card_copy = res.result;
        this.$message.success('上传成功！');
      } else {
        this.$message.warning('上传失败！');
      }
    },
    successUploadtwo(res, file) {
      console.log(res);
      if (res.result) {
        this.id_card_national = res.result;
        this.$message.success('上传成功！');
      } else {
        this.$message.warning('上传失败！');
      }
    },
    submit() {
      if (!this.info.real_name) {
        this.$message.warning('请输入姓名！');
      } else if (!this.info.phone) {
        this.$message.warning('请输入手机号！');
      } else if (!phoneReg.test(this.info.phone)) {
        this.$message.warning('手机号格式不正确！');
      } else if (!this.info.code) {
        this.$message.warning('请输入验证码！');
      } else if (this.info.code.length !== 6) {
        this.$message.warning('验证码输入错误！');
      } else if (!this.info.company_name) {
        this.$message.warning('请输入公司名称！');
      } else if (!this.id_card_copy) {
        this.$message.warning('请上传身份证正面照片！');
      } else if (!this.id_card_national) {
        this.$message.warning('请上传身份证背面照片！');
      } else {
        const params = {
          id_card_copy: this.id_card_copy,
          id_card_national: this.id_card_national,
          real_name: this.info.real_name,
          phone: this.info.phone,
          code: this.info.code,
          company_name: this.info.company_name
        };
        console.log(params);
        api.saveMyinfo(params).then(res => {
          console.log(res);
          if (res.result && !res.result.msg) {
            this.$message.success('认证成功！');
            this.$router.go(-1);
          } else {
            this.$message.warning(res.result.msg);
          }
        });
      }
    },
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      console.log(file);
      //   this.cardImg = file.url;
      //   this.dialogVisible = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.index-container {
  padding-bottom: 2PX;
  margin-top: 122PX;
  background-color: #f8f7f6;
}
.right-content {
  width: 72%;
  padding: 42PX 58PX 55PX;
  background-color: #ffffff;
  box-shadow: 0PX 3PX 16PX 0PX rgba(228, 228, 228, 0.35);
  .r-title {
    padding-bottom: 20PX;
    font-size: 20PX;
    font-weight: bold;
  }
}

.info-content {
  .module-box {
    padding: 32PX 30PX;
    margin-bottom: 30PX;
    background: rgba(246, 246, 246, 0.43);
    &:nth-child(2) {
      margin-bottom: 70PX;
    }
  }
  .info-name {
    padding-bottom: 10PX;
    color: #666666;
  }
  .info-input {
    margin-bottom: 16PX;
    border-bottom: 1PX solid #efefef;
    span {
      padding: 0 30PX;
      color: #f7b750;
    }
    .code-text {
      padding-left: 0;
      cursor: pointer;
    }
  }
  .phone-input {
    width: 30%;
  }
}
/deep/ {
  .el-input__inner {
    padding: 0;
    color: #333333;
    border: none;
    background-color: transparent;
  }
  .el-icon-plus {
    padding-top: 36PX;
  }
}
.card-img-box {
  display: flex;
  margin-bottom: 15PX;
}
.card-text {
  display: flex;
  justify-content: space-between;
  width: 50%;
  padding-bottom: 34PX;
  color: #666666;
}
.right-text {
  display: flex;
  align-items: center;
  .iconfont-icon {
    padding-right: 6PX;
    font-size: 16PX;
    color: #f6ab2b;
  }
}
.upload-box {
  width: 180PX;
  height: 126PX;
  //   padding-top: 36PX;
  margin-right: 30PX;
  text-align: center;
  border: 1PX dashed #e7e7e7;
  .el-icon-plus {
    font-size: 32PX;
    color: #e7e7e7;
  }
  .el-upload-tip {
    padding-top: 18PX;
    color: #999999;
  }
}
.card-imgs {
  width: 180PX;
  height: 126PX;
}
.eg-text {
  width: 180PX;
  margin-right: 30PX;
  color: #f6ab2b;
  text-align: center;
  cursor: pointer;
}
.confirm-button {
  width: 342PX;
  margin: 0 auto;
  font-size: 20PX;
  color: #ffffff;
  line-height: 64PX;
  text-align: center;
  background-color: #f6ab2b;
  border-radius: 32PX;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
.card-img {
  width: 300PX;
  height: 210PX;
  margin: 0 auto 24PX;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.text-tip {
  font-size: 22PX;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/editInfo.vue